export const catalogosAdminKeys = {
  all: ['catalogos-admin'] as const,
  lists: () => [...catalogosAdminKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...catalogosAdminKeys.lists(), filters] as const,
  details: () => [...catalogosAdminKeys.all, 'detail'] as const,
  detail: (id: number) => [...catalogosAdminKeys.details(), id] as const,
  categorias: () => [...catalogosAdminKeys.all, 'categorias'] as const,
  categoria: (code: string) => [...catalogosAdminKeys.all, 'categoria', code] as const,
};
